import {
  Button,
  FormControl,
  InputAdornment,
  TextField,
  Tooltip
} from "@mui/material";
import Person from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import PostcodeIcon from "@mui/icons-material/LocalPostOfficeRounded";
import * as React from "react";
import {Fragment, useRef} from "react";
import {HelpOutline} from "@mui/icons-material";


export function OwnerAddress({values, handleChange, errors, data} ) {

  let ownerFirstname = useRef();
  let ownerLastname = useRef();
  let ownerStreet = useRef();
  let ownerSuburbTown = useRef();
  let ownerState = useRef();
  let ownerPostcode = useRef();


  // copy delivery address over to property owner function
  function handleCopyFromDelivery(e) {

    ownerFirstname.current.value = values.owner_firstname = values.delivery_firstname;
    ownerLastname.current.value = values.owner_lastname = values.delivery_lastname;
    ownerStreet.current.value = values.owner_street = values.delivery_number_street;
    ownerSuburbTown.current.value = values.owner_suburb_town = values.delivery_suburb;
    ownerState.current.value = values.owner_state = values.delivery_state;
    ownerPostcode.current.value = values.owner_postcode = values.delivery_postcode;
    document.getElementById('place-order').click();

  }


  return (

    <Fragment>
          <h5 className="text-secondary mb-3">
            Property Owner Address  <Tooltip title="What is the address of the property owner." arrow><HelpOutline /></Tooltip>
          </h5>

        {
          data.shipping === '0' ?
          <Button className="mb-3" variant="contained" onClick={handleCopyFromDelivery}>Copy from Delivery Address</Button>
          : null
        }


          <FormControl fullWidth className="mb-4">
            <TextField name="owner_firstname"
                       label="Owner Firstname"
                       inputRef={ownerFirstname}
                       value={values.owner_firstname}
                       onChange={handleChange}
                       error={!!Boolean(errors.owner_firstname)}
                       helperText={errors.owner_firstname}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><Person/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

          <FormControl fullWidth className="mb-4">
            <TextField name="owner_lastname" label="Owner Lastname" variant="outlined"
                       onChange={handleChange}
                       inputRef={ownerLastname}
                       value={values.owner_lastname}
                       error={!!Boolean(errors.owner_lastname)}
                       helperText={errors.owner_lastname}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><Person/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

          <FormControl fullWidth className="mb-4">
            <TextField name="owner_phone" label="Owner Phone"
                       onChange={handleChange}
                       value={values.owner_phone}
                       error={!!Boolean(errors.owner_phone)}
                       helperText={errors.owner_phone}
                       InputProps={{
                         startAdornment: (<InputAdornment position='start'><PhoneIcon/></InputAdornment>)
                       }}
            />
          </FormControl>

          <FormControl fullWidth className="mb-4">
            <TextField name="owner_email" label="Owner Email Address"
                       onChange={handleChange}
                       value={values.owner_email}
                       error={!!Boolean(errors.owner_email)}
                       helperText={errors.owner_email}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><EmailIcon/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

          <FormControl fullWidth className="mb-4">
            <TextField name="owner_street" label="Owner Street Number & Name"
                       inputRef={ownerStreet}
                       onChange={handleChange}
                       value={values.owner_street}
                       error={!!Boolean(errors.owner_street)}
                       helperText={errors.owner_street}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><HomeIcon/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

          <FormControl fullWidth className="mb-4">
            <TextField name="owner_suburb_town" label="Owner Suburb or Town"
                       inputRef={ownerSuburbTown}
                       onChange={handleChange}
                       value={values.owner_suburb_town}
                       error={!!Boolean(errors.owner_suburb_town)}
                       helperText={errors.owner_suburb_town}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><HomeIcon/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

          <div className="mb-4">
                <select className="form-select p-3"
                        ref={ownerState}
                        value={values.owner_state}
                        name="owner_state"
                        onChange={handleChange}
                        placeholder="State"
                        style={!!errors.owner_state ? {borderColor: 'red'} : null}
                >
                  <option value="">-- Select State --</option>
                  <option value="ACT">Australian Capital Territory</option>
                  <option value="NSW">New South Wales</option>
                  <option value="NT">Northern Territory</option>
                  <option value="QLD">Queensland</option>
                  <option value="SA">South Australia</option>
                  <option value="TAS">Tasmania</option>
                  <option value="VIC">Victoria</option>
                  <option value="WA">Western Australia</option>
                </select>
            {!!errors.owner_state ? <p style={{letterSpacing: '0.03333em', fontSize: '0.75rem', marginLeft: '14px'}}
                                       className="text-danger">{errors.owner_state}</p> : null}
          </div>


          <FormControl fullWidth className="mb-5">
            <TextField name="owner_postcode" label="Owner Postcode"
                       inputRef={ownerPostcode}
                       onChange={handleChange}
                       value={values.owner_postcode}
                       error={!!Boolean(errors.owner_postcode)}
                       helperText={errors.owner_postcode}
                       InputProps={{
                         startAdornment: (
                           <InputAdornment position='start'><PostcodeIcon/></InputAdornment>
                         )
                       }}
            />
          </FormControl>

    </Fragment>
  );

}
